
import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function ConsumptionReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Ingredient Name(Code)",
      accessorKey: "Ingredient Name(Code)",
    },
    {
      header: "Quantity/Amount",
      accessorKey: "Quantity/Amount",
    },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  const [selectButton] = useState([
    
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Consumption Report "}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
     
    </main>
  );
}

export default ConsumptionReport;
